/**
 * @generated SignedSource<<48d6808475f1a9ea45c1fba41ceebeb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbMobileRefineMenuFilterDimensions_filters$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuInputRangeDimensions_filters">;
  readonly " $fragmentType": "SbMobileRefineMenuFilterDimensions_filters";
}>;
export type SbMobileRefineMenuFilterDimensions_filters$key = ReadonlyArray<{
  readonly " $data"?: SbMobileRefineMenuFilterDimensions_filters$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbMobileRefineMenuFilterDimensions_filters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbMobileRefineMenuFilterDimensions_filters",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_filters"
    }
  ],
  "type": "SearchBrowseFilter",
  "abstractKey": null
};

(node as any).hash = "f356903fe90b1a4ca17af752e1fb88a0";

export default node;
